/* eslint-disable prettier/prettier */
export const card = [
  'flex flex-col items-center gap-3 border border-[#E1E1E1] rounded-[1.25rem] w-full',
  'px-5 pt-5 bg-white bg-[linear-gradient(0deg,_#EBEBFF_4.18%,_rgba(246,246,255,0.46)_6.99%,_rgba(255,255,255,0)_9.83%)]',
  'md:rounded-t-[1.25rem] md:rounded-b-none md:bg-none md:bg-white'
].join(' ');

export const imageWrap = [
  'relative w-full',
  'h-[12.546rem]',
  'md:h-[12.1rem] md:w-full'
].join(' ');

export const image = 'object-contain';

export const keyword = [
  'rounded-lg bg-[#F3F4F6] px-2 py-1 font-semibold tracking-[-0.019rem] text-[#6B7280]',
  'text-[0.938rem] leading-[1.56rem] tracking-[-0.019rem]',
  'md:text-[0.936rem] md:leading-[1.566rem] md:shadow-[inset_0_0_0_0.063rem_rgba(51,50,54,0.05)]'
].join(' ');

export const contentWrap = 'w-full flex flex-col items-start gap-[0.875rem]';

export const keywordRow = 'flex flex-wrap gap-[0.313rem]';

export const description = [
  'font-medium tracking-[-0.019rem] text-[#374151] whitespace-pre-line',
  'text-[1rem] leading-[1.56rem] tracking-[-0.019rem]',
].join(' ');
